// Service Swiper
const serviceSwiper = new Swiper('.service-swiper', {
  slidesPerView: 1, 
  effect: 'fade', 
  autoplay: true,
  autoplay: {
    delay: 5000,
  }
});

let isClick = false;

// Trigger relevant content section & start video over when slide changes
serviceSwiper.on('slideChange', function () {

  // Start video from beginning
  const currentSlide = serviceSwiper.slides[serviceSwiper.realIndex];
  const video = currentSlide.querySelector('video');

  if (video) {
    video.currentTime = 0;
    video.play();
  }

  // Pause all other videos
  serviceSwiper.slides.forEach((slide, index) => {
    if (index !== serviceSwiper.realIndex) {
      const currentVideo = slide.querySelector('video');
      if (currentVideo) {
        currentVideo.pause();
      }
    }
  });
  if(isClick) {
    isClick = false;
    return;
  }

  const index = serviceSwiper.realIndex;

  const triggers = document.querySelectorAll('.service-swiper-nav .toggle-trigger');

  triggers.forEach((trigger, i) => {
    if(i === index) {
      var evt = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });

      let canceled = !trigger.dispatchEvent(evt);
      isClick = false;
    }
  });
});

// Calculate progress bar height
serviceSwiper.on('autoplayTimeLeft', function (s, time, progress) {
  const progressPercentage = (1 - progress) * 100 + '%';
  document.querySelector('.service-swiper-nav .item.active .progress-bar').style.setProperty('height', progressPercentage);
});

// Go to slide on click
document.querySelectorAll('.service-swiper-nav .item').forEach( item => {
  item.addEventListener('click', function () {
    isClick = true;
    const index = item.getAttribute('data-index');
    serviceSwiper.slideTo(index);
  });
});